
  var date = new Date();
  var weekday = new Array(7);

  weekday[0] = "Sunday";
  weekday[1] = "Monday";
  weekday[2] = "Tuesday";
  weekday[3] = "Wednesday";
  weekday[4] = "Thursday";
  weekday[5] = "Friday";
  weekday[6] = "Saturday";

  var dayofweek = weekday[date.getDay()];


  var d = new Date();
  var numberofday = d.getDate();
  
  var month = new Array();
  month[0] = "January";
  month[1] = "February";
  month[2] = "March";
  month[3] = "April";
  month[4] = "May";
  month[5] = "June";
  month[6] = "July";
  month[7] = "August";
  month[8] = "September";
  month[9] = "October";
  month[10] = "November";
  month[11] = "December";

  var d = new Date();
  var monthname = month[d.getMonth()];
  var fullyear = d.getFullYear();
	

  try {
    document.getElementById("cherry-header-date").innerHTML = dayofweek + ', ' + monthname + ' ' + numberofday + ', ' + fullyear;
  }
  catch(err) {
    // all good
  }

  

